var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92.1185,
    height: 92.1185,
    transform: "translate(0 0.331299)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_719_2368)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_719_2368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 40,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.2313 44.9727L52.461 57.7049L65.2313 70.4372H50.6372L37.8614 57.7049L50.6372 44.9727H65.2313ZM50.6372 23.1541L26.9165 46.7934L34.216 54.0678L65.2313 23.1551H50.6372V23.1541Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_719_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8589 57.7096L45.1546 64.9833L65.2266 44.9773H50.6314L37.8589 57.7096Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_719_2368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 40,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2313 44.9727L52.461 57.7049L65.2313 70.4372H50.6372L37.8614 57.7049L50.6372 44.9727H65.2313ZM50.6372 23.1541L26.9165 46.7934L34.216 54.0678L65.2313 23.1551H50.6372V23.1541Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_719_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.6372 23.1541H65.2313L34.216 54.0667L26.9165 46.7923L50.6372 23.1541Z",
    fill: "#39CEFD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_719_2368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 40,
    height: 48
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2313 44.9727L52.461 57.7049L65.2313 70.4372H50.6372L37.8614 57.7049L50.6372 44.9727H65.2313ZM50.6372 23.1541L26.9165 46.7934L34.216 54.0678L65.2313 23.1551H50.6372V23.1541Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_719_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1621 64.9826L50.6389 70.4372H65.233L52.4616 57.7083L45.1621 64.9826Z",
    fill: "#03569B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_719_2368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 40,
    height: 48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2313 44.9727L52.461 57.7049L65.2313 70.4372H50.6372L37.8614 57.7049L50.6372 44.9727H65.2313ZM50.6372 23.1541L26.9165 46.7934L34.216 54.0678L65.2313 23.1551H50.6372V23.1541Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_719_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9882 61.2451L52.4616 57.7083L45.1621 64.9826L55.9882 61.2451Z",
    fill: "url(#paint0_linear_719_2368)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_719_2368",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 23,
    width: 40,
    height: 48
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2313 44.9727L52.461 57.7049L65.2313 70.4372H50.6372L37.8614 57.7049L50.6372 44.9727H65.2313ZM50.6372 23.1541L26.9165 46.7934L34.216 54.0678L65.2313 23.1551H50.6372V23.1541Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_719_2368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8589 57.7013L45.1589 50.427L52.459 57.7013L45.1589 64.9757L37.8589 57.7013Z",
    fill: "#16B9FD"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2227 44.9754L52.4524 57.7076L65.2227 70.4399H50.6286L37.8528 57.7076L50.6286 44.9754H65.2227ZM50.6286 23.1567L26.908 46.7961L34.2075 54.0705L65.2227 23.1578H50.6286V23.1567Z",
    fill: "url(#paint1_radial_719_2368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_719_2368",
    x1: 47.2949,
    y1: 66.3865,
    x2: 50.2557,
    y2: 59.8471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A237E",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A237E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_719_2368",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.006 15.5303) scale(58.0114 57.8273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_719_2368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.3148,
    height: 47.282,
    fill: "white",
    transform: "translate(26.9084 23.1611)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.8f64453c2948a3d137f21de03310d2ed.svg";
export { ForwardRef as ReactComponent };